export enum PersonActionTypes {
    SET_CURRENT_PROFILE = 'USER/SET_CURRENT_PROFILE'
}